import { PayloadAction } from '@reduxjs/toolkit';
import { DTO_META__field_info } from '@shared/dto/generation/graph_invoke/_fields/_base/DTO_META__field_info';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { STATE__ui } from '../STATE__ui';

export const LOCAL__ui_generation_graph_set_hovered_field = (
  payload: DTO_META__field_info = DTO_META__field_info.CREATE_STUB(),
): PayloadAction<DTO_META__field_info> => ({
  type: ENUM__redux_action.UI_GENERATION_GRAPH_SET_HOVERED_FIELD,
  payload,
});

export function INIT_LOCAL__ui_generation_graph_set_hovered_field(state: STATE__ui, action: PayloadAction<DTO_META__field_info>) {
  state.g_graph__field_hovered = action.payload.clone();
}
